'use client'

import { Play } from 'lucide-react'
import Image from 'next/image'
import { useState } from 'react'

const ABOUT_VIDEO_URL =
  'https://player.scaleup.com.br/embed/80c5c882e7d6d136b1b547fdd5d7836c3420671c?autoplay=1'

const ABOUT_VIDEO_COVER = '/img/estetus/hero-2026/hero-bg.webp'

export function AboutVideo() {
  const [isPlaying, setIsPlaying] = useState(false)

  return (
    <div className="relative aspect-video w-full shrink-0 overflow-hidden rounded-3xl bg-[#E8F1FF] lg:w-142.5">
      {isPlaying ? (
        <iframe
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; fullscreen; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          className="size-full border-0"
          src={ABOUT_VIDEO_URL}
          title="Vídeo de apresentação da Estetus"
        />
      ) : (
        <button
          aria-label="Assistir ao vídeo de apresentação da Estetus"
          className="relative flex size-full cursor-pointer items-end justify-start text-left focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[#074AB7]/40"
          onClick={() => setIsPlaying(true)}
          type="button"
        >
          <Image
            alt=""
            className="object-cover object-[85%_center]"
            fill
            sizes="(min-width: 1024px) 570px, 100vw"
            src={ABOUT_VIDEO_COVER}
          />
          <span className="absolute inset-0 bg-linear-to-r from-[#074AB7]/90 via-[#074AB7]/55 to-transparent" />

          <span className="absolute inset-0 flex items-center justify-center">
            <span className="flex size-16 items-center justify-center rounded-full bg-white text-[#074AB7] shadow-lg lg:size-20">
              <Play
                aria-hidden
                className="ml-1 size-7 lg:size-8"
                fill="currentColor"
              />
            </span>
          </span>

          <span className="relative flex flex-col gap-1 p-5 font-montserrat text-white lg:p-7">
            <span className="font-bold text-xl leading-6 tracking-[-0.03em] lg:text-2xl">
              Conheça a Estetus
            </span>
            <span className="text-sm text-white/85 lg:text-base">
              Assista ao vídeo de apresentação
            </span>
          </span>
        </button>
      )}
    </div>
  )
}
